import { useRoute } from '#imports'

export const useArtists = () => {
	const route = useRoute()
	const { resolveArtistObject } = useResolve()
	const { hash, slug } = route.params
	const nuxtApp = useNuxtApp()
	const { loadSongs, initialLoad, setSongListResource, filterString } = useSonglists({
		songlistApiResource: nuxtApp.$singaApi.Artists.artistSongs,
		params: { page_size: 5, sort: 'top' }
	})
	const artistMetaDescription = ref('')

	/**
	 * Resolves the artist page with the given slug and hash
	 */
	const resolveArtistData = async () => await resolveArtistObject(slug.toString(), hash.toString())

	const getArtistObject = async () => {
		if (import.meta.prerender) { return }
		if (import.meta.client) {
			const { getStateItem } = useContentCacheStore()
			const artistSlug = slug.toString() + '/' + hash.toString()
			if (getStateItem.slug === artistSlug) {
				return getStateItem.item as Artist
			}
		}
		return await resolveArtistData()
	}

	/**
	 * Loads artist's songs with the given parameters
	 */
	const loadArtistSongs = async (id: number, options?: { page?: number, sort?: string }): Promise<LoadSongsResult> => {
		const params = {
			page_size: 25,
			...(options?.page && { page: options.page }),
			...(options?.sort && { sort: options.sort }),
			...(filterString.value && { search: filterString.value })
		}

		const response = await loadSongs(params, id)
		if (response?.results) {
			const firstFiveSongs = response.results.slice(0, 5)
			artistMetaDescription.value = createMetadescription(firstFiveSongs, 160)
			return response
		}
		return {
			results: [],
			nextPage: false,
			count: 0,
			page: options?.page || 1
		}
	}

	const setArtistSongListResource = (resource: any) => {
		setSongListResource(resource)
	}

	return {
		initialLoad,
		loadSongs,
		artistMetaDescription,
		loadArtistSongs,
		setArtistSongListResource,
		getArtistObject,
		filterString
	}
}
